import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { getRevenueLeadByCurrencyData } from "../../../../services/event/dashboard/dashboardServices";

const RevenueLeadByCurrency = (props) => {
  const { startMonth, endMonth, subDomain} = props;

  const [chartData, setChartData] = useState({
    series: [], 
    options: {},
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
       
        const response = await getRevenueLeadByCurrencyData({
          sub_domain: subDomain,
          fromDate:startMonth,
          toDate: endMonth, 
        });


        // Ensure response contains the expected structure
        if (response && response.series && response.labels) {
          setChartData((prevData) => ({
            ...prevData,
            ...prevData.series,
            series: response.series,
            options: {
              ...prevData.options,
              ...response.options, // Merge new options with existing ones
              labels: response.labels,
              legend: { position: "bottom" }, 
              title: { text: `Total: ${response.total}`, align: "left",
              style: {
                fontSize: "16px",
                fontWeight: 800,
                color: "#333",
              },
            },
              tooltip: {
                y: {
                  formatter: (value) => {
                    return `${value}`; 
                  },
                },
              },
            },
          }));
        } else {
          console.error("Unexpected response structure:", response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [subDomain,startMonth,endMonth]);

  return (
    <>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="donut"
        height={350}
      />
    </>
  );
};

export default RevenueLeadByCurrency;
